import React from 'react';

function TreatmentPlanPrintPopUp({ allData, demoData, genData }) {
  const goalPlanstatus = {
    1: 'In-progress',
    2: 'Completed',
    3: 'Closed',
    4: 'Deferred',
  };

  return (
    <>
      <table
        width="734px"
        align="left"
        valign="top"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ fontSize: 14, marginBottom: 20 }}
      >
        <tbody>
          <tr width="734px">
            <td
              align="center"
              width="734px"
              style={{ fontSize: 21, color: '#000' }}
            >
              Treatment plan
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        cellSpacing={0}
        cellPadding={0}
        border={0}
        align="center"
        style={{ paddingBottom: 10 }}
      >
        <tbody>
          <tr width="734px">
            <td width="407px" style={{ paddingTop: 10 }} valign="top">
              <table
                width="407px"
                align="left"
                border={0}
                cellSpacing={0}
                cellPadding={0}
              >
                <tbody>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ fontSize: 19 }}>
                      {demoData.patientName}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      {demoData.age} {demoData.gender} DoB: {demoData.dob}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      {demoData.address}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      {demoData.email} <b>{demoData.phoneLabel}</b>
                      {': '}
                      {demoData.phone}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      <b>Race:</b> {demoData.race}, <b>Ethnicity:</b>{' '}
                      {demoData.ethincity}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td width="327px" style={{ paddingTop: 10 }} valign="top">
              <table
                width="327px"
                align="left"
                border={0}
                cellSpacing={0}
                cellPadding={0}
                valign="top"
              >
                <tbody>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 0 }}>
                      <b>Provider:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 0 }}>
                      {genData.providerName}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Resource:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.resourceName}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Date:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.review_date}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Procedure:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.procName}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Review in:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.review_in}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Treatment duration:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.treatment_duration}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Treatment mode:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.treatment_mode}
                    </td>
                  </tr>
                  <tr rowSpan={2} width="327px">
                    <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                      <b>Start date:</b>
                    </td>
                    <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                      {genData.start_date}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Problem:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              <span
                dangerouslySetInnerHTML={{ __html: genData?.selectProblem }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Presenting Problem:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: genData?.PresentingProblem,
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Behavior:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              <span dangerouslySetInnerHTML={{ __html: genData?.behavior }} />
            </td>
          </tr>
        </tbody>
      </table>
      {/* <div>
        {allData?.goalData &&
          allData?.goalData.map((item, i) => (
            <div key={i} className="cntnt-blk prgrs-vw-blk">
              <div className="assmnt-nt-hdng">
                <span className="hshtg-lnk">Goal #{i + 1}:</span>

                <span className="clear-left maroon common-fontsize">
                  Added: {item?.goalAddedDate}
                </span>
                <span className="hshtg-lnk"></span>
              </div>
              <div className="assmnt-nt-rw med-value clear-bottom fontsize14">
                <span dangerouslySetInnerHTML={{ __html: item?.goalDetail }} />
              </div>
              {item?.objArr.map((obj, j) => (
                <div
                  key={j}
                  className="width100 clear-bottom"
                  style={{ borderBottom: '1px dotted orange' }}
                >
                  <div className="assmnt-nt-sbhdng">
                    <span className="assmnt-nt-rw tp-chld-hdng">
                      Objective #{j + 1}:
                    </span>
                    <span className="assmnt-nt-rw normal">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: obj?.objDetail,
                        }}
                      />
                    </span>
                    <span className="tp-status-rw">
                      <span className="normal maroon width100">
                        Added: {obj?.objAddedDate}
                      </span>
                      <span className="normal clear-right clear-left maroon width100 ">
                        Status: {goalPlanstatus[obj?.objStatus]}
                      </span>
                      <span className="normal clear-right clear-left maroon width100">
                        Completion:&nbsp;
                        <span
                          dangerouslySetInnerHTML={{
                            __html: obj?.completionDate,
                          }}
                        />
                      </span>
                    </span>
                  </div>
                  {obj?.interDetailArr.map((inter, k) => (
                    <div key={k} className="assmnt-nt-sbhdng">
                      <span className="assmnt-nt-rw tp-chld-hdng">
                        Intervention #{k + 1}
                      </span>
                      <span className="assmnt-nt-rw normal">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: inter?.intervention_title,
                          }}
                        />
                      </span>
                      <span className="tp-status-rw">
                        <span className="normal maroon">
                          Added: {inter?.addedDateIntervention}
                        </span>
                      </span>
                    </div>
                  ))}
                  {obj?.reviewDetailArr.map((rev, l) => (
                    <div key={l} className="assmnt-nt-sbhdng">
                      <span className="assmnt-nt-rw tp-chld-hdng orange-txt">
                        Review #{l + 1}
                      </span>
                      <span className="assmnt-nt-rw normal">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: rev?.review_title,
                          }}
                        />
                      </span>
                      <span className="tp-status-rw">
                        <span className="normal maroon">
                          Added: {rev?.addedDateReview}
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
      </div> */}

      {/* stop  */}

      {allData?.goalData &&
        allData?.goalData.map((item, i) => (
          <table
            width="734px"
            align="left"
            border={0}
            cellSpacing={0}
            cellPadding={0}
            style={{ marginTop: 15 }}
            key={i}
          >
            <div>
              <tr width="734px">
                <th
                  width="734px"
                  style={{ fontWeight: 'bold', fontSize: 14, color: '#000' }}
                  align="left"
                >
                  Goal #{i + 1}:
                </th>
              </tr>
              <tr width="734px">
                <td width="734px" style={{ paddingTop: 5, paddingLeft: 15 }}>
                  <span
                    dangerouslySetInnerHTML={{ __html: item?.goalDetail }}
                  />
                </td>
              </tr>
            </div>

            {item?.objArr.map((obj, j) => (
              <tbody key={j}>
                <tr width="734px">
                  <td
                    width="719px"
                    style={{
                      fontWeight: 'bold',
                      color: '#000',
                      paddingTop: 15,
                      paddingLeft: 15,
                      textAlign: 'center',
                    }}
                  >
                    <span>
                      <span style={{ float: 'left' }}>Objective #{j + 1}:</span>
                      <span>Status: {goalPlanstatus[obj?.objStatus]}</span>
                      <span style={{ float: 'right' }}>
                        Completion:&nbsp;
                        <span
                          dangerouslySetInnerHTML={{
                            __html: obj?.completionDate,
                          }}
                        />
                      </span>
                    </span>
                  </td>
                </tr>
                <tr width="734px">
                  <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: obj?.objDetail,
                      }}
                    />
                  </td>
                </tr>

                {/* new */}

                {obj?.interDetailArr.map((inter, k) => (
                  <span key={k}>
                    <tr width="734px">
                      <td
                        width="719px"
                        style={{
                          fontWeight: 'bold',
                          color: '#000',
                          paddingTop: 15,
                          paddingLeft: 15,
                        }}
                      >
                        Intervention #{k + 1}:
                      </td>
                    </tr>
                    <tr width="734px">
                      <td
                        width="719px"
                        style={{ paddingTop: 5, paddingLeft: 15 }}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: inter?.intervention_title,
                          }}
                        />
                      </td>
                    </tr>
                  </span>
                ))}
                {obj?.reviewDetailArr.map((rev, l) => (
                  <span key={l}>
                    <tr width="734px">
                      <td
                        width="719px"
                        style={{
                          fontWeight: 'bold',
                          color: '#000',
                          paddingTop: 15,
                          paddingLeft: 15,
                        }}
                      >
                        Review #{l + 1}:
                      </td>
                    </tr>
                    <tr width="734px">
                      <td
                        width="719px"
                        style={{ paddingTop: 5, paddingLeft: 15 }}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: rev?.review_title,
                          }}
                        />
                      </td>
                    </tr>
                  </span>
                ))}
              </tbody>
            ))}
          </table>
        ))}
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              <span
                dangerouslySetInnerHTML={{
                  __html: allData?.getSignStr,
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default TreatmentPlanPrintPopUp;
